export default "__VITE_ASSET__e469487e__"